// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_policy_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { PasswordPolicy } from "./password_push_flow";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyRef
 */
export interface PasswordPolicyRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest
 */
export interface PasswordPolicySearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPolicyRef refs = 3
     */
    refs: PasswordPolicyRef[];
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse
 */
export interface PasswordPolicySearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPolicy list = 1
     */
    list: PasswordPolicy[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyRef$Type extends MessageType<PasswordPolicyRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyRef>): PasswordPolicyRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyRef): PasswordPolicyRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyRef
 */
export const PasswordPolicyRef = new PasswordPolicyRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicySearchServiceSearchRequest$Type extends MessageType<PasswordPolicySearchServiceSearchRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicySearchServiceSearchRequest>): PasswordPolicySearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicySearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicySearchServiceSearchRequest): PasswordPolicySearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.password_push.v1.PasswordPolicyRef refs */ 3:
                    message.refs.push(PasswordPolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicySearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.password_push.v1.PasswordPolicyRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            PasswordPolicyRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest
 */
export const PasswordPolicySearchServiceSearchRequest = new PasswordPolicySearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicySearchServiceSearchResponse$Type extends MessageType<PasswordPolicySearchServiceSearchResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPolicy },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicySearchServiceSearchResponse>): PasswordPolicySearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicySearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicySearchServiceSearchResponse): PasswordPolicySearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPolicy list */ 1:
                    message.list.push(PasswordPolicy.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicySearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPolicy list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPolicy.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse
 */
export const PasswordPolicySearchServiceSearchResponse = new PasswordPolicySearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPolicySearchService
 */
export const PasswordPolicySearchService = new ServiceType("c1.api.password_push.v1.PasswordPolicySearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPolicySearchServiceSearchRequest, O: PasswordPolicySearchServiceSearchResponse }
]);
